import React, {useRef} from "react";
import {useTheme} from "../../../contexts/theme";
import StyledAutoComplete from "../StyledAutocomplete/StyledAutocomplete";
import {Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {updateClipTags} from "../../../queries/clipQueries";
import {VideoContentTypes} from "../../../types/clipTypes";
import {useVideoContentTagsOptions} from "../../../contexts/VideoContentTagsOptions";
import videoContentTags from "./VideoContentTags";

interface VideoContentTagsProps {
    tags: string[];
    onTagSelected?: (tags: string[]) => void;
    onInputChange?: (text: string) => void;
    contentType: VideoContentTypes;
    label?: string
    labelStyle?: {fontSize?: string, fontWeight?: string, color?: string, marginRight?: string};
}

const VideoContentTags : React.FC<VideoContentTagsProps> = ({label = '', labelStyle = {}, onTagSelected=() => {}, tags, onInputChange=() => {}, contentType}) => {

    const {videoContentTagsOptions} = useVideoContentTagsOptions()
    const prevTags = useRef<string[]>([]);



    return (
        <Box display="flex" alignItems="center">
            <Typography sx={labelStyle}>{label}</Typography>
            <Box flex={1}>
                <StyledAutoComplete
                    name={contentType + 'tags'}
                    label={''}
                    options={videoContentTagsOptions}
                    value={tags}
                    onChange={(_, newValue) => onTagSelected(newValue)}
                    freeSolo={true}
                    variant={'standard'}
                    limitTags={3}
                />
            </Box>

        </Box>

    )
}

export default VideoContentTags;